const COMPONENT_EVENTS = {
  Load: {
    description: 'Triggered when user loads page',
    eventHub: {
      code: 'LOAD',
      action: 'Page loaded'
    }
  },
  Logout: {
    description: 'Triggered when user logs out',
    eventHub: {
      code: 'LOGOUT',
      action: 'Clicked logout'
    }
  },
  Continue: {
    description: 'Triggered when user continues',
    eventHub: {
      code: 'CONTINUE',
      action: 'Clicked continue'
    }
  },
  Save: {
    description: 'Triggered when user saves screen data',
    eventHub: {
      code: 'SAVE',
      action: 'Clicked save and continue'
    }
  },
  PolicyMe: {
    description: 'Triggered when user redirects to PolicyMe',
    eventHub: {
      code: 'POLICYME',
      action: 'Clicked PolicyMe'
    }
  },
  Willful: {
    description: 'Triggered when user redirects to Willful',
    eventHub: {
      code: 'WILLFUL',
      action: 'Clicked Willful'
    }
  },
  Youthfully: {
    description: 'Triggered when user redirects to Youthfully',
    eventHub: {
      code: 'YOUTHFULLY',
      action: 'Clicked Youthfully'
    }
  },
  Contribution: {
    description: 'Triggered when user redirects to contribution',
    eventHub: {
      code: 'CONTRIBUTION',
      action: 'Clicked make a contribution'
    }
  },
  Dashboard: {
    description: 'Triggered when user redirects to dashboard',
    eventHub: {
      code: 'DASHBOARD',
      action: 'Clicked go to dashboard'
    }
  }
};

const createEventAction = (eventAction, componentName) => {
  return [`${componentName ?? ''}`, `${eventAction ?? ''}`].filter((str) => !!str).join('_');
};

module.exports = {
  addBeneficiaryApplicationComponentEvents: {
    AddBenePlanSelect: {
      code: 'PLANSELECT',
      events: {
        Load: {
          description: COMPONENT_EVENTS.Load.description,
          eventHub: {
            code: COMPONENT_EVENTS.Load.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Load.eventHub.action, 'PlanSelect')
          }
        },
        Continue: {
          description: COMPONENT_EVENTS.Continue.description,
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Continue.eventHub.action, 'PlanSelect')
          }
        }
      }
    },
    AddBenePlanSelectError: {
      code: 'ERROR',
      events: {
        Load: {
          description: COMPONENT_EVENTS.Load.description,
          eventHub: {
            code: COMPONENT_EVENTS.Load.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Load.eventHub.action, 'PlanSelectError')
          }
        }
      }
    },
    AddBeneReview: {
      code: 'ADDBENEREVIEW',
      events: {
        Submit: {
          description: 'Triggered when add a bene is submitted',
          eventHub: {
            code: COMPONENT_EVENTS.Continue.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Continue.eventHub.action, 'ReviewPage')
          }
        },
        Logout: {
          description: COMPONENT_EVENTS.Logout.eventHub.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Logout.eventHub.action, 'ReviewPage')
          }
        },
        Edit: {
          description: 'Triggered when user edits a question',
          eventHub: {
            code: 'EDIT',
            action: 'ReviewPage_Clicked edit [$.screenName]'
          }
        }
      }
    },
    AddBeneSuccess: {
      code: 'SUCCESS',
      events: {
        Logout: {
          description: COMPONENT_EVENTS.Logout.eventHub.description,
          eventHub: {
            code: COMPONENT_EVENTS.Logout.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Logout.eventHub.action, 'SuccessPage')
          }
        },
        Done: {
          description: 'Triggers when done is clicked',
          eventHub: {
            code: 'DONE',
            action: 'SuccessPage_Clicked done'
          }
        },
        Contribution: {
          description: COMPONENT_EVENTS.Contribution.eventHub.description,
          eventHub: {
            code: COMPONENT_EVENTS.Contribution.eventHub.code,
            action: 'SuccessPage_Clicked add money'
          }
        },
        PolicyMe: {
          description: COMPONENT_EVENTS.PolicyMe.eventHub.description,
          eventHub: {
            code: COMPONENT_EVENTS.PolicyMe.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.PolicyMe.eventHub.action, 'SuccessPage')
          }
        },
        Willful: {
          description: COMPONENT_EVENTS.Willful.eventHub.description,
          eventHub: {
            code: COMPONENT_EVENTS.Willful.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Willful.eventHub.action, 'SuccessPage')
          }
        },
        Youthfully: {
          description: COMPONENT_EVENTS.Youthfully.eventHub.description,
          eventHub: {
            code: COMPONENT_EVENTS.Youthfully.eventHub.code,
            action: createEventAction(COMPONENT_EVENTS.Youthfully.eventHub.action, 'SuccessPage')
          }
        },
        Load: {
          description: 'Triggered when add a beneficiary success is loaded',
          eventHub: {
            code: 'COMPLETE',
            action: COMPONENT_EVENTS.Load.eventHub.action
          }
        }
      }
    }
  }
};
